import { curry, type PlatformEvent } from 'lib/util'

/**
 * Chain Util Event Handler.
 *
 * Consecutively calls all `eventHandlers` by passing to them all the arguments passed to the
 * returned function.
 *
 * @param eventHandlers the event handlers to chain
 */
export default (...eventHandlers: Gaia.AppModule.EventHandler[]) => curry(async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
) => {
  event?.persist?.()
  let result: any = null

  try {
    result = eventHandlers?.length
      // waiting for last handler
      ? await eventHandlers.reduce(
        async (acc, eventHandler) => {
          // waiting for the previous promise to finish before the next handler is executed
          await acc
          return eventHandler(module, component, event)
        }, Promise.resolve(),
      )
      : console.warn('ATTENTION!!! No event handlers set to chain event handler')
  } catch (error) { // throwing errors is the way to break the chain
    console.debug('Chain event handler interrupted: ', error)
  }
  return result
})
